import React, { useState } from "react";
import { Button, Flex, Text } from "@jsq/ds/core";
import { UploadModal } from "../UploadModal";

// Single source of truth for the DEX upload experience copy — reused by the
// standalone Storybook demo and by Canopy. Don't duplicate these strings in
// story files or host apps.
export const DOCUMENT_UPLOAD_COPY = {
  heading: "Dex",
  triggerLabel: "Upload a document",
  modalTitle: "Upload document",
  modalDescription: "Upload a K-1 or PCAP PDF for data extraction",
} as const;

export interface DocumentUploadProps {
  // Injected by the host (Canopy, the live story, a test resolver) so the host
  // owns the data binding + ApolloProvider.
  onUpload: (file: File) => Promise<void>;
}

export const DocumentUpload = ({ onUpload }: DocumentUploadProps) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <section aria-labelledby="document-upload-heading">
      <Flex justifyContent="space-between" alignItems="center">
        <Text variant="h1" id="document-upload-heading">
          {DOCUMENT_UPLOAD_COPY.heading}
        </Text>
        <Button
          variant="primary"
          onClick={() => setShowModal(true)}
          data-testid="open-upload-modal"
        >
          {DOCUMENT_UPLOAD_COPY.triggerLabel}
        </Button>
      </Flex>
      <UploadModal
        show={showModal}
        onHide={() => setShowModal(false)}
        title={DOCUMENT_UPLOAD_COPY.modalTitle}
        description={DOCUMENT_UPLOAD_COPY.modalDescription}
        onUpload={onUpload}
      />
    </section>
  );
};
